
import './search.css'
export default function Search(props) {
    function opensearchbox() {
        if(props.opensearch === false){
            props.setOpensearch(true)
        }
    }
    return(
            <div class="search-box">
            <input type="text" id='search' placeholder={props.language === 'en' ? 'Search ...' : 'جست و جو ...'} onClick={opensearchbox} onChange={props.searching} ></input>
            <label for="search"></label>
        </div>
    )
}